import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full min-h-screen flex items-center justify-center bg-cream overflow-hidden px-4 py-20 md:py-0" data-id="element-80">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-sage/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-81" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-gold/10 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-82" />

      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center relative z-10" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="space-y-8 text-center md:text-left" data-id="element-84">
          <span className="inline-block px-4 py-1.5 rounded-full bg-sage/10 text-forest text-sm font-medium tracking-wide uppercase" data-id="element-85">
            Guía Práctica de Nutrición y Hábitos
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-forest leading-tight" data-id="element-86">
            Controla tu Menopausia con{' '}
            <span className="text-sage italic" data-id="element-87">Microajustes Diarios</span>: Sin
            Dietas Extremas
          </h1>

          <p className="text-lg md:text-xl text-warmBrown/90 leading-relaxed max-w-xl mx-auto md:mx-0" data-id="element-88">
            Imagina despertar cada día sin saber si vas a enfrentar bochornos
            inesperados, fatiga constante o antojos difíciles de controlar. Has
            probado dietas, suplementos y ejercicios que terminan por agotarte
            más. Sientes que tu cuerpo ya no responde igual.
          </p>

          <div className="pt-4" data-id="element-89">
            <motion.a href="#pricing" whileHover={{
            scale: 1.03,
            boxShadow: '0 10px 25px -5px rgba(107, 143, 113, 0.4)'
          }} whileTap={{
            scale: 0.98
          }} className="inline-flex items-center gap-2 bg-sage text-white px-8 py-4 rounded-full text-lg font-medium shadow-lg hover:bg-forest transition-colors duration-300" data-id="element-90">
              Empezar el Plan
              <ArrowRight className="w-5 h-5" data-id="element-91" />
            </motion.a>
            <p className="mt-4 text-sm text-warmBrown/70" data-id="element-92">
              Acceso inmediato • Compra segura
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative" data-id="element-93">
          <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl border-4 border-white transform rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-94">
            <img src="https://cdn.magicpatterns.com/uploads/649G8vQAcH71a1QmHJEegL/Menopaucia_en_control.png" alt="Portada de la guía Menopausia en Control" className="w-full h-auto object-cover" data-id="element-95" />
          </div>
          {/* Decorative frame behind image */}
          <div className="absolute inset-0 border-2 border-gold/30 rounded-2xl transform -rotate-2 scale-105 z-0" data-id="element-96" />
        </motion.div>
      </div>
    </section>;
}